/* 🤖 this file was generated by svg-to-ts */
export const mgcIconPavilionCuteRe: {
  name: 'pavilion-cute-re';
  data: string;
} = {
  name: 'pavilion-cute-re',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M6.012 10.603a1.106 1.106 0 0 0-.3.242 12.2 12.2 0 0 1-.358.397c-.381.402-.354.04-.354 4.685V20h-.553c-.694 0-.893.052-1.141.3a.96.96 0 0 0 0 1.4c.326.325-.406.3 8.694.3 7.14 0 8.13-.007 8.31-.061.378-.112.69-.537.69-.939 0-.237-.12-.514-.303-.697-.251-.251-.448-.303-1.144-.303H19v-4.053c0-4.642.025-4.306-.351-4.702a11.3 11.3 0 0 1-.362-.401 1.096 1.096 0 0 0-.302-.242c-.169-.082-.197-.082-5.988-.082-5.815 0-5.817 0-5.985.083M8 16.24V20H7v-7.52h1zm6 0V20h-4v-7.52h4zm3 0V20h-1v-7.52h1z"/></svg>`
};
